import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss']
})
export class PrintComponent implements OnInit {

  @Input('dataList') dataList;
  @Input('printData') printData: any;
  @Output() backToMain = new EventEmitter();

  column: string[] = [];
  tableList: any[] = [];

  constructor() { }

  ngOnInit() {
    this.column = this.listColumn();
    this.tableList = JSON.parse(JSON.stringify(this.dataList));
    this.column = this.listColumn();
    setTimeout(() => {
      (<HTMLInputElement>document.getElementById("mySidenav")).style.display = 'none';
      (<HTMLInputElement>document.getElementById("header")).style.display = 'none';
      document.title = this.printData.Title;
      window.print();
      this.callEmit();
    }, 100);
  }

  callEmit() {
    (<HTMLInputElement>document.getElementById("mySidenav")).style.display = 'block';
    (<HTMLInputElement>document.getElementById("header")).style.display = 'block';
    this.backToMain.emit(true);
  }

  listColumn(): string[] {
    if (this.dataList.length)
      return Object.keys(this.dataList[0]);
    return [];
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src2505023020/src/src/app/common/print/print/print.component.ts